<template>
    <div id="userLogin">
		<div class="big-img"></div>
		<form class="dataFrom">        
			<div class="vant-input">
				<keep-alive>
					<se-autocomplete v-model="iccid" :fetchsuggestions="querySearch"  @select="handleSelect" placeholder="请输入您的流量卡号"></se-autocomplete>
				</keep-alive>
			</div>
			<div class="formLine">
				<mt-button type="primary" size="large" @click.prevent="userQuerySIM">查询</mt-button> 
			</div>       
		</form>
		<!-- <div class="tip">
             <img
      style="width: 100%; margin-top: 1rem;"
      src="@/assets/title.png"
      alt=""
     /> -->
			<!-- <div class="title">亲爱的客户 您好！感谢你对我们的信赖于支持</div>
			<div class="tip-content">1、套餐为月底清零的用户 请在26号前续费次月，未续费的用户 将会影响卡的正常使用！</div>
            <br/>
			<div class="tip-content">2、套餐为26号清零的用户，请在22号前续费次月，未续费的用户 将会影响卡的正常使用！</div>
              <br/>
			<div class="tip-content">3、套餐为30天有效期的用户 请在套餐过期前5天 续费充值，未续费的用户 将会影响卡的正常使用！</div>
              <br/>
			<div class="tip-content">4、激活以后请勿随意更换卡槽和设备，更换设备和卡槽需要解锁  一月2次</div> 
            
            -->
		</div>
    </div>
    
</template>
<script>
import {	Dialog	} from 'vant';
import { Toast } from 'vant';
import { wxRequest } from '@/api/user.js' 
import SeAutocomplete from '@/components/SeAutocomplete'
import Advertisement from '@/components/Advertisement'
export default {
    components: {SeAutocomplete,Advertisement},
    data(){
        return {
            iccid: '',
            code: '',
            showAds: true,
            gzh:'',
            realNameList: ['1192351241053663232', '1224969664338063360', '1255666672321163264', '7DA692EC992B45E297450F40DEDC5614', '8601954A2B074E80AACAAF32C5EE232C', 
            '960F3276EFAA4ED2999754895F4BCCB4', 'B1E112B9F1D8420E9072D9F47D6A135E', '1275705014286807040', 
            '1275706083402313728', '1274979554988912640', '1279289937396494336'],
            suolangList: ['1275704520822747136']
        }
    },
    methods: { 
        querySearch(queryString, cb) {
            var listAll = this.getAutoCompleteData('iccidList');         
            var results = queryString ? listAll.filter(this.createFilter(queryString)) : listAll;      
            cb(results);      
        },
        createFilter(queryString) {
            return (listAll) => {
                return (listAll.indexOf(queryString) == 0);
            };
        },
        handleSelect(item){
            this.iccid = item 
        },       
        userQuerySIM(){
            if(this.iccid == ''){
                Dialog.alert({title: '提示', message:'请输入ICCID号'})
                return false;
            }

            let recordLoginText = this.iccid;//存放用户登录时输入的文本，将用于首页显示

            let data = {
                requestId: this.iccid,
                code: this.code
            }
			wxRequest("sim/bind",data, "get").then(res => {
                if(res.data.code == 200){
                    let record = res.data.data;
                    let iccid = record.iccid;
                    localStorage.setItem('isHuiYuan', record.isHuiYuan);
                    localStorage.setItem('isAgentLogin',1);
                    localStorage.setItem("isAuth", record.isAuth);
					localStorage.setItem('mobile', record.mobile);
                    localStorage.setItem('supplierTypeName', record.supplierTypeName);
                    localStorage.setItem('wxHeadImg', record.wxHeadImg);
                    localStorage.setItem('wxNickName', record.wxNickName);
                    localStorage.setItem('recordLoginText', recordLoginText);
                    localStorage.setItem('supplierName', record.supplierName);
                    localStorage.setItem('iccid', iccid);
                    localStorage.setItem('intoNo', record.intoNo);
                     localStorage.setItem('yucun', record.yucun);
                     sessionStorage.setItem("isLine", true);
                    localStorage.setItem('openId', record.openId);
                    localStorage.setItem('agentId', record.agentId);
                       localStorage.setItem("salePrice", record.salePrice);//充值金额 元
                     localStorage.setItem("havePrice", record.havePrice);//得到金额 元
                    localStorage.setItem('flowRatePool', record.flowRatePool);
                    localStorage.setItem("ishavePkg", record.ishavePkg);
                    localStorage.setItem("isSale", record.isSale);
                    localStorage.setItem("kefuUrl", record.kefuUrl);
                     localStorage.setItem("priceImgUrl", record.priceImgUrl); 
                    localStorage.setItem("ishavePrice", record.ishavePrice);
                     localStorage.setItem("shebeiLogin",0);
                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;                 
                    this.$store.state.iccid = iccid;
                    this.$store.state.flowRatePool=res.data.data.flowRatePool;
                     localStorage.setItem("userPhone", record.userPhone);
                        this.$store.state.userPhone = record.userPhone;

                    this.$store.state.intoNo = record.intoNo;
                    this.setAutoCompleteData('iccidList', recordLoginText, 10)
                    //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
                    let cardType = record.supplierCode;
                    if(this.realNameList.indexOf(cardType) > -1){
                        //暂不做处理
                    }
                     if(record.isToYuCun!=1){
                         this.$router.replace('/user/openPrice');
                    }else  if((record.isSale == 1||record.isSale == 3)&&record.ishavePrice==0){
                    this.$router.replace('/user/simOpens');
              } else if(record.isSale>0&&record.ishavePrice==0){
                this.$router.replace('/user/simOpens');
            } else if(this.suolangList.indexOf(cardType) > -1){
                        window.location.href = `http://wx.iot688.com/iot/iotSimfind?cn=${iccid}&yurlyb=wx.ischenxin.com/#/user/home`
                    }else{
                        let _data = { iccid: record.iccid }
                        wxRequest("bindPhone/state", _data, "post").then(res => {
                            if(res.data.code == 200){
                                let result = res.data.data;
                                localStorage.setItem('applyChangeSimState', result.applyChangeSimState);
                                 if(result.bindState == 2){
                                     this.$router.push({
                                         path:'/user/bindPhoneOnely',
                                        query:{
                                             iccid: record.iccid
                                         }
                                     });
                                 }else{
                                    localStorage.setItem('phoneNo', result.userPhone);
                                    this.$router.replace('/user/home');
                                }
                            }else{
                                Dialog.alert({title: '提示', message:res.data.message});
                            }
                        })
                    }   
                }else{
                    Dialog.alert({title: '提示', message:res.data.message});
                }
            })
        },


        //获取url参数
        getQueryVariable(variable){
           var query = window.location.search.substring(1);
           var vars = query.split("&");
           for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
           }
           return false;
        },
        
        goBuyCard() {
            window.location.href = 'http://10086.sm.iot000.cn/#/user/login2'
        }

        // goto(path){
        //     //广告点击统计
        //     wxRequest("link/click",{url: path}, "get").then(res => {
        //         window.location.href = path;
        //     });
            
        // },


    },
    async created(){
        var source = this.getQueryVariable('source') ? this.getQueryVariable('source') : process.env.VUE_APP_APPID;
      
        var appid  = source ? source : process.env.VUE_APP_APPID;
         //获取总部公众号appid
		await wxRequest("/sim/appId",{}, "post").then(res => {
            if(res.data.code == 200){
                 appid=res.data.data.collectAppid;
                
                // if(appid != res.data.data.collectAppid ){
                //     this.$store.commit('setIsHeadquarterAppid', 'false');
                //     localStorage.setItem('isHeadquarterAppid', false);
                // }else{
                //     this.$store.commit('setIsHeadquarterAppid', 'true');
                //     localStorage.setItem('isHeadquarterAppid', true);
                // }      
            }
        });
         this.$store.commit('setIsHeadquarterAppid', 'true');
        localStorage.setItem('isHeadquarterAppid', true); 
        localStorage.setItem('appid', source);
        console.log(appid)
        //先查询是否是乐刷支付 如果是乐刷支付 就不用授权了
        await wxRequest("sim/get/pay/state", {  iccid: localStorage.getItem('iccid') }, 'post').then(res => {
            localStorage.setItem('payCode',res.data.code);
            if (res.data.code == 200) {
                localStorage.setItem('leshuaPay',1);
                this.iccid = localStorage.getItem('recordLoginText');
            } else {
                localStorage.setItem('leshuaPay',2);
            }
        })
        var redirectUrl = window.location.href;   
                var index = redirectUrl.indexOf('code');
                redirectUrl = encodeURIComponent(redirectUrl);
                if (index < 0) {
                     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
                } else {
                    var search = window.location.search;
                    console.log('search',search);
                    var startIndex = search.indexOf('code');
                    var endIndex = search.indexOf('&', startIndex);
                    var str = search.slice(startIndex, endIndex);
                    var code = str.slice(str.indexOf('=') + 1);
                    this.code = code ;
                    this.iccid = localStorage.getItem('recordLoginText');
                 }
       

    },

    mounted() {

    },


    beforeDestory(){
       
    }
}
</script>


<style scoped lang="less">
*{
	padding:0;
	margin:0;
}
#userLogin{
	padding:0;
	.tip{
		width:88%;
		margin:120px auto;
		.title{
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #000000;
			line-height: 20px;
			margin-bottom:10px;
		}
		.tip-content{
			font-size:12px;
			color: #999;
			line-height: 20px;
			margin-bottom: 4px;
		}
	}
	.big-img {
		width:100%;
		height:263px;
		border-radius:0;
		background: url(../../assets/home/icon18.png)no-repeat center top;
		background-size:100% ;
	}
	.dataFrom{
		width:80%;
		margin:0 auto;
		position:absolute;
		top:11.875rem;
		left: 0;
		right:0;
		bottom:0;
		background:#fff;
		border-radius:10px;
		text-align: center;
		padding:20px ;
		box-shadow: 0px 4px 10px 0px #DAECFF;
		height:124px;
		button{
			width:100%;
			line-height:46px;
			border-radius: 40px;
			font-size: 14px;
			height:56px;
			background:#455EF1;
			border:0px solid #282E3E;
			margin:0 auto;
		}
	}
	.vant-input{
		/deep/ input[type=text]{
			background: #efefef;
			border-color: #efefef;
			border-radius: 40px;
			color: #999;
			text-align: center;
			width:100%;
			height:56px;
			margin:0 auto;
			margin-bottom:14px;
		}
		// /deep/ input[type=text]::-webkit-input-placeholder {
		// 	font-size: 12px;
		// 	text-align: center;
		// }
	}
}
.tabClick{
	color:#F44034;
	font-size:1rem;
	position: absolute;
	bottom: 10%;
	left: 0;
	right: 0;
	text-align: center;
	margin: auto;
}
.formLine{
	.mint-button--primary{
		background: #24BAC8;
		border-radius: 20px;
		height: 44px;
	}
}
// h2 {
//     display: flex;
//     align-items: center;
//     .yema-img {
//         height: 20px;
//         padding-right: 3px;
//     }
// }


</style>